<template>
    <div class="loader-wrapper" v-if="loading">
      <div class="loader"></div>
    </div>
    <section class="authentication-form" v-else>
      <div class="innerpage-decor">
        <div class="innerpage-circle1"><img :src='"../assets/images/Testimonial2.png"' alt=""></div>
        <div class="innerpage-circle2"><img :src='"../assets/images/Testimonial1.png"' alt=""></div>
      </div>
      <div>
        <h2 class="title text-center"><span>Self Service</span></h2>
        <p class="text-center">Welcome to FMC Ebutte Metta, Self Service Payment.</p>
        <div class="card shadow">
          <img class="img-logo mx-auto" :src='"../assets/images/fmce-logo.png"' alt="">
          <div class="form-button text-center mt-4">
            <button type="button" @click="printReceipt" class="btn btn-custom btn-lg btn-block theme-color">Continue</button>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
/* eslint-disable no-undef */
/* eslint-disable new-cap */
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'Sample',
  data () {
    return {
      patientNo: '',
      loading: false
    }
  },
  mounted () {},
  methods: {
    submit () {
      this.loading = true
      let payload = {
        names: 'Adewale Jamiu',
        amount: 2000,
        email_address: 'fmce.ssi@nacs.com.ng',
        phone_number: '08030988470',
        currency: 'NGN',
        merch_txnref: 'RT99084780',
        merchantid: '1278'
      }

      this.makePayment(payload)
    },

    makePayment (params) {
      let method = 'post'
      var form = document.createElement('form')
      form.submit_function = form.submit

      form.setAttribute('method', method)
      form.setAttribute('action', 'https://demo.globalpay.com.ng/GlobalPayAPI/Paymentgatewaycapture.aspx')

      for (var key in params) {
        var hiddenField = document.createElement('input')
        hiddenField.setAttribute('type', 'hidden')
        hiddenField.setAttribute('name', key)
        hiddenField.setAttribute('value', params[key])

        form.appendChild(hiddenField)
      }

      document.body.appendChild(form)
      form.submit_function()
    },

    printReceipt () {
      let ePosDev = new window.epson.ePOSDevice()
      ePosDevice.current = ePosDev

      ePosDev.connect(printerIPAddress, printerPort, (data) => {
        if (data === 'OK') {
          ePosDev.createDevice(
            'local_printer',
            ePosDev.DEVICE_TYPE_PRINTER,
            { crypto: true, buffer: false },
            (devobj, retcode) => {
              if (retcode === 'OK') {
                printer.current = devobj
                setConnectionStatus(STATUS_CONNECTED)
              } else {
                throw retcode
              }
            }
          )
        } else {
          throw data
        }
      })

      let prn = printer.current
      if (!prn) {
        alert('Not connected to printer')
        return
      }
      prn.addText('Hello world printer')
      prn.addFeedLine(5)
      prn.addCut(prn.CUT_FEED)

      prn.send()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/sample.vue